import React, { Component } from "react";
import PropTypes from "prop-types";
import UploadFileSVG from "../../../Assets/svg/FileArrowUp.svg";
import UploadFolderSVG from "../../../Assets/svg/Folder.svg";

class UploadOptions extends Component {
  static propTypes = {
    handleShowAndHideFileUploader: PropTypes.func.isRequired,
    handleShowAndHideFolderUploader: PropTypes.func.isRequired,
  };

  render() {
    const { handleShowAndHideFileUploader, handleShowAndHideFolderUploader } =
      this.props;

    return (
      <div className="absolute right-0 top-12 w-52 font-inter text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-200 shadow-lg overflow-hidden z-50">
        <div
          className="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-blue-50 transition-colors"
          onClick={handleShowAndHideFileUploader}
        >
          <img src={UploadFileSVG} alt="Upload File" className="w-5 h-5" />
          <span>Upload File</span>
        </div>
        <div
          className="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-blue-50 transition-colors border-t border-gray-100"
          onClick={handleShowAndHideFolderUploader}
        >
          <img src={UploadFolderSVG} alt="Upload Folder" className="w-5 h-5" />
          <span>Upload Folder</span>
        </div>
      </div>
    );
  }
}

export default UploadOptions;
